export const onFilterChangedEvent = ({ gridRef, onFilterChanged, params }) => {
  
  if (onFilterChanged) onFilterChanged(params);

  gridRef.current.api.refreshCells({ force: true });
}